import { Box } from "@mui/material";
import Tabs from "components/basic/tabs";
import useUrlParamState from "hooks/useUrlParamState";
import { useSupportUnreadCount } from "pages/dashboard/pages/support/supportApi";

import Analytics from "../analytics";
import ExpiringTab from "./components/ExpiringTab";
import SupportTab from "./components/SupportTab";
import UsersTab from "./components/UsersTab";
import VendorsTab from "./components/VendorsTab";
import { useAdminSummary } from "./adminApi";
import { ADMIN_TABS } from "./constants";
import { AdminTab } from "./types";

const withCount = (label: string, count?: number) =>
  count ? `${label} (${count})` : label;

/**
 * Admin tools for whoever is in ADMIN_EMAILS. Every query below is guarded
 * again server-side, so reaching this by URL only shows errors.
 */
const Admin = () => {
  const [tabParam, setTabParam] = useUrlParamState("tab", "analytics");
  const { summary, refresh } = useAdminSummary();
  const unreadTickets = useSupportUnreadCount(true);
  const tab = tabParam as AdminTab;

  const tabs = ADMIN_TABS.map((item) => ({
    ...item,
    label:
      item.path === "vendors"
        ? withCount(item.label, summary?.pendingGoogleReviews)
        : item.path === "support"
          ? withCount(item.label, unreadTickets)
          : item.label,
  }));

  return (
    <Box display="flex" flexDirection="column" height="100%">
      <Tabs
        selectedTab={tab}
        setSelectedTab={(next) => setTabParam(next)}
        tabs={tabs}
      />
      <Box flex={1} minHeight={0} overflow="auto">
        {tab === "vendors" && <VendorsTab onChanged={refresh} />}
        {tab === "expiring" && <ExpiringTab />}
        {tab === "users" && <UsersTab />}
        {tab === "support" && <SupportTab />}
        {tab === "analytics" && <Analytics />}
      </Box>
    </Box>
  );
};

export default Admin;
